//DARK THEME COLORS

export const ORANGE_1 = '#F07843';
export const ORANGE_2 = '#F38759';
export const ORANGE_3 = '#F6956C';
export const ORANGE_4 = '#F9A37F';
export const ORANGE_5 = '#FBB092';
export const ORANGE_6 = '#FDBEA4';
export const ORANGE_7 = '#FECBB6';
export const ORANGE_8 = '#FFD8C8';
export const ORANGE_9 = '#FFE5DA';
export const ORANGE_10 = '#FFF2ED';

export const LIME_1 = '#A5E11B';
export const LIME_2 = '#B0E63E';
export const LIME_3 = '#BBEB61';
export const LIME_4 = '#C6F084';
export const LIME_5 = '#D1F5A7';
export const LIME_6 = '#DCFACA';
export const LIME_7 = '#E4FCCF';
export const LIME_8 = '#EAFDD9';
export const LIME_9 = '#F0FEE3';
export const LIME_10 = '#F7FFF0';

export const DARK_1 = '#000';
export const DARK_2 = '#0E0E12';
export const DARK_3 = '#0D1116';
export const DARK_4 = '#161D26';
export const DARK_5 = '#292E33';

export const DARK_6 = '#1A1F25';

export const GROUP_CARD_HEADER = '#0C1C40';
export const GROUP_CARD_BACKGROUND = '#16294F';
export const GROUP_CARD_ROW_BACKGROUND = '#0E2149';
export const GROUP_CARD_ROW_BORDER = '#1B2F57';
export const GROUP_CARD_BORDER = '#243B67';

export const NAVY_0 = '#222B3B';
export const NAVY_1 = '#1A316F';
export const NAVY_2 = '#1D3E95';
export const NAVY_3 = '#89A7CD';
export const NAVY_4 = '#B3C5DB';
export const NAVY_5 = '#091325';
export const NAVY_6 = '#3A4251';
export const NAVY_7 = '#D5E3ED';
export const NAVY_8 = '#D7DFEA';
export const NAVY_9 = '#2251D1';
export const NAVY_10 = '#0E2D63';
export const NAVY_11 = '#151F30';
export const NAVY_12 = '#6886DA';

export const RED_0 = '#300A0A';
export const RED_1 = '#541212';
export const RED_2 = '#871D1D';
export const RED_3 = '#EDABAB';
export const RED_4 = '#C12929';
export const RED_5 = '#F8DDDD';

//LIGHT THEME COLORS

export const BLUE_1 = '#265b77';
export const BLUE_2 = '#3594B4';
export const BLUE_3 = '#51A0BD';
export const BLUE_4 = '#69ABC5';
export const BLUE_5 = '#80B7CE';
export const BLUE_6 = '#95C3D6';
export const BLUE_7 = '#ABCFDE';
export const BLUE_8 = '#C0DBE6';
export const BLUE_9 = '#D5E7EF';
export const BLUE_10 = '#EAF3F7';
export const BLUE_11 = '#F6FCFF';
export const BLUE_12 = '#005C7A';

//COMMON COLORS

export const ERROR = '#FF5761';
export const WARNING = '#F0B152';
export const SUCCESS = '#36C555';
export const WHITE = '#FFF';
export const BLACK = '#000';
export const GRAY_1 = '#3F3F3F';
export const GRAY_2 = '#505050';
export const GRAY_3 = '#616161';
export const GRAY_4 = '#747474';
export const GRAY_5 = '#868686';
export const GRAY_6 = '#999999';
export const GRAY_7 = '#ADADAD';
export const GRAY_8 = '#C1C1C1';
export const GRAY_9 = '#D5D5D5';
export const GRAY_10 = '#EAEAEA';
export const GRAY_11 = '#F8F8F8';
export const GRAY_12 = '#444141';
export const GRAY_13 = '#9CA3AF';
export const GRAY_14 = '#474747';
export const GRAY_15 = '#C7C7C7';
export const GRAY_16 = '#FAFAFA';
export const GRAY_17 = '#E1E1E1';
export const GRAY_18 = '#A6A6A6';
export const GRAY_19 = '#1C1C1C';
export const GRAY_20 = '#666666';
export const GRAY_21 = '#535A66';

export const SIDEBAR = '#0E2D63';
